<div class="sidebar-wrapper">
  <div class="dark-sidebar-container border-1 card rounded-3">
    <div class="dark-sidebar-header">
      <div class="dark-sidebar-logo-wrapper text-center mt-3">
        <img :src="$clientLogo" alt="Logo" class="dark-sidebar-logo img-fluid" />
      </div>
      <hr class="fw-bold mb-4 mt-1 mx-4 dark-sidebar-divider" />
    </div>

  <div class="dark-sidebar-body">
    <div class="dark-sidebar-nav-container">
      <!-- Sidebar -->
      <template v-for="section in processedSections" :key="section.id">
        <ul class="dark-nav-list flex-column me-1 text-start">
          <!-- Section Title -->
          <span 
            v-if="section.title" 
            class="dark-section-title text-xxs fw-bold p-0"
          >
            {{ section.title }}
          </span>

          <!-- Menu Items -->
          <li 
            v-for="item in section.items" 
            :key="item.id" 
            class="dark-nav-item"
            :class="{ 'mt-0 mb-0 p-2': user_info.user_role === 'SystemAdmin' }"
          >
            <!-- Regular Link Item -->
            <router-link
              v-if="!item.type || item.type === 'link'"
              :to="item.route"
              class="dark-nav-link fw-bold"
              :class="{ 'd-flex align-items-center': item.badge }"
              active-class="dark-active"
            >
              <span :class="{ 'd-flex align-items-center': item.badge }">
                <!-- SVG Icon -->
                <img 
                  v-if="!isFontAwesomeIcon(getIcon(item.icon))"
                  :src="getIcon(item.icon)" 
                  class="icon-small me-2" 
                />
                <!-- Font Awesome Icon -->
                <i 
                  v-else
                  :class="['fa', getIcon(item.icon), 'me-2', 'dark-nav-fa-icon', 'icon-small']"
                ></i>
                {{ item.label }}
              </span>
              <!-- Badge Support -->
              <span 
                v-if="item.badge && getBadgeValue(item.badge) > 0" 
                class="unread-badge ms-2"
              >
                {{ getBadgeValue(item.badge) }}
              </span>
            </router-link>

            <!-- Dropdown Item -->
            <template v-if="item.type === 'dropdown'">
              <a 
                class="dark-nav-link dark-nav-dropdown fw-bold" 
                @click="toggleDropdown(item.id)"
                :class="{ 'dark-expanded': shouldShowDropdown(item) }"
              >
                <!-- SVG Icon -->
                <img 
                  v-if="!isFontAwesomeIcon(getIcon(item.icon))"
                  :src="getIcon(item.icon)" 
                  class="icon-small me-2" 
                />
                <!-- Font Awesome Icon -->
                <i 
                  v-else
                  :class="['fa', getIcon(item.icon), 'me-2', 'dark-nav-fa-icon', 'icon-small']"
                ></i>
                {{ item.label }}
                <i class="fa fa-chevron-down dark-dropdown-arrow"></i>
              </a>

              <!-- Dropdown Children -->
              <ul v-show="shouldShowDropdown(item)" class="dark-dropdown-list">
                <li 
                  v-for="child in item.children" 
                  :key="child.id" 
                  class="dark-dropdown-item"
                  :class="{ 'has-active': isRouteActive(child.routeName) }"
                >
                  <router-link 
                    :to="child.route" 
                    class="dark-dropdown-link" 
                    active-class="dark-active"
                  >
                    {{ child.label }}
                  </router-link>
                </li>
              </ul>
            </template>
          </li>
        </ul>
      </template>
    </div>
    <div class="dark-sidebar-spacer"></div>

    <!-- Logout Section -->
    <ul class="dark-logout-section">
      <li class="dark-nav-item">
        <a class="dark-nav-link fw-bold" @click="route_to" href="#" role="button">
          <img :src="sidebarIcons.logout" class=" icon-small me-2" />
          Logout
        </a>
      </li>
    </ul>
  </div>
</div>
</div>